/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll virtual dice with any number of sides.`)
};

const es_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza dados virtuales con cualquier número de caras.`)
};

const de_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Würfle virtuelle Würfel mit beliebiger Seitenzahl.`)
};

const nl_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gooi virtuele dobbelstenen met elk gewenst aantal zijden.`)
};

const fr_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez des dés virtuels avec n'importe quel nombre de faces.`)
};

const it_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancia dadi virtuali con qualsiasi numero di facce.`)
};

const pt_br2_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role dados virtuais com qualquer número de lados.`)
};

const pt_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance dados virtuais com qualquer número de faces.`)
};

const ja_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意の面数のサイコロを仮想で振ります。`)
};

const zh_dice_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掷出任意面数的虚拟骰子。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_tool_description", locale)
	if (locale === "en") return en_dice_tool_description(inputs)
	if (locale === "es") return es_dice_tool_description(inputs)
	if (locale === "de") return de_dice_tool_description(inputs)
	if (locale === "nl") return nl_dice_tool_description(inputs)
	if (locale === "fr") return fr_dice_tool_description(inputs)
	if (locale === "it") return it_dice_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_dice_tool_description(inputs)
	if (locale === "pt") return pt_dice_tool_description(inputs)
	if (locale === "ja") return ja_dice_tool_description(inputs)
	return zh_dice_tool_description(inputs)
};